import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';
import moment from 'moment';
import {FormattedMessage} from 'react-intl';

import DatePicker from 'material-ui-pickers/DatePicker';
import MomentUtils from '@date-io/moment';
import MuiPickerUtilsProvider from 'material-ui-pickers/MuiPickersUtilsProvider';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';

const picker = ({disabled, field, helpButton, input, isUtc, label, messageId, meta, meta: {active, error, touched, warning}, ...rest}) => {
    return (
        <FormControl disabled={disabled} fullWidth>
            <MuiPickerUtilsProvider utils={MomentUtils} moment={isUtc ? moment.utc : moment}>
                <DatePicker
                    InputLabelProps={{shrink: true}}
                    label={[messageId ? <FormattedMessage key={messageId} id={messageId}/> : label, helpButton]}
                    leftArrowIcon={<ChevronLeft/>}
                    onChange={val => !!val ? input.onChange(val.toISOString()) : null}
                    onClear={() => input.onChange('')}
                    rightArrowIcon={<ChevronRight/>}
                    value={input.value ? moment(input.value) : null}
                    {...rest}
                />
            </MuiPickerUtilsProvider>
            <FormHelperText error={!!error ? !!error : undefined}>
                {do {
                    if (touched && !!error && error && error !== 'Invalid Date Format.') {
                        error;
                    } else if (active && touched && !error && !!warning) {
                        warning;
                    }
                }}
            </FormHelperText>
        </FormControl>
    );
};

const DatePickerInput = ({ field, label, helpButton, show, ...rest }) => {

    if (show !== undefined && !show) {
        return null;
    }

    return (
        <span className="input">
            <Field
                component={picker}
                field={field}
                label={label}
                name={field}
                {...rest}
            />
            {helpButton}
        </span>
    );
};

DatePickerInput.propTypes = {
    field: PropTypes.string.isRequired,
    helpButton: PropTypes.node,
    label: PropTypes.string,
    messageId: PropTypes.string,
    type: PropTypes.string
};

export default DatePickerInput;


// WEBPACK FOOTER //
// ./src/components/common/form/DatePicker.js